/** A letter field the user maps a CSV column to. Ported from the PHP tool. */
export interface FieldDef {
  key: string;
  label: string;
  optional?: boolean;
  aliases: string[];
}

export const FIELDS: readonly FieldDef[] = [
  {
    key: "company_name",
    label: "Company Name",
    aliases: ["company", "co", "organisation", "organization", "org", "business", "account"],
  },
  {
    key: "first_name",
    label: "First Name",
    aliases: ["fname", "firstname", "first", "given_name", "givenname", "forename"],
  },
  {
    key: "last_name",
    label: "Last Name",
    aliases: ["lname", "lastname", "last", "surname", "family_name", "familyname"],
  },
  {
    key: "title",
    label: "Job Title",
    aliases: ["job_title", "jobtitle", "position", "role", "designation", "job"],
  },
  {
    key: "location",
    label: "Address",
    aliases: [
      "address",
      "street",
      "street_address",
      "city",
      "region",
      "state",
      "country",
      "suburb",
      "area",
      "office",
    ],
  },
  {
    key: "date",
    label: "Date",
    optional: true,
    aliases: ["letter_date", "letterdate", "doc_date", "docdate", "sent_date"],
  },
];

export const REQUIRED_FIELD_KEYS = FIELDS.filter((f) => !f.optional).map((f) => f.key);

export interface LabelTemplateOption {
  key: string;
  label: string;
}

export const LABEL_TEMPLATES: readonly LabelTemplateOption[] = [
  { key: "avery_l7162", label: "Avery L7162 (2 x 8)" },
];

export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;
